const firebaseConfig = {
    apiKey: "AIzaSyC8nmnmskXorDjuBoyXgsvpUWPAsh8N5Vg",
    authDomain: "crypto-tracker-76cb5.firebaseapp.com",
    projectId: "crypto-tracker-76cb5",
    storageBucket: "crypto-tracker-76cb5.appspot.com",
    messagingSenderId: "1035720021940",
    appId: "1:1035720021940:web:4487b75fd0f6bc5f9604e1"
  };

  export default firebaseConfig;